import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {Observable, take} from "rxjs";
import {UrlBuilder} from "../models/frontend_entities/UrlBuilder";
import Constants from "../Constants";

@Injectable()
export class InvitationRequestService {

  //region CONSTRUCTOR
  constructor (
    private httpClient: HttpClient
  ) {}
  //endregion

  //region GET
  validateInvitationUuid(
    uuid: string
  ): Observable<{ id: number, userId: number, email: string, valid: boolean}> {
    const url: string = new UrlBuilder(Constants.URLS.invitation.validateInvitation)
      .param('uuid', uuid)
      .build();

    return this.httpClient.get<
      { id: number, userId: number, email: string, valid: boolean}
    >(url).pipe(take(1));
  }
  //endregion

}
